
import 'zoomforth_polyfills/polyfills_app_extended.js';

import 'zoomforth_zfrespond/views/optout.less';
import 'zoomforth_zfrespond/views/respond.completed_modal.less';
import 'zoomforth_zfrespond/views/respond.edit_media_response.less';
import 'zoomforth_zfrespond/views/respond.edit_text_response.less';
import 'zoomforth_zfrespond/views/respond.less';
import 'zoomforth_zfrespond/views/respond.media_response_thumbnail.less';
import 'zoomforth_zfrespond/views/respond.mobile_video_interstitial.less';
import 'zoomforth_zfrespond/views/respond.questions_header.less';
import 'zoomforth_zfrespond/views/respond.respond_app.less';
import 'zoomforth_zfrespond/views/tester.less';
import 'zoomforth_zfrespond/views/welcome.less';

import 'zoomforth_zfrespond/views/camera_help_modal.less';

import 'expose-loader?ZFRESPOND_JST!./legacy_zfrespond_jst.js';

import 'jquery';
import 'expose-loader?_!lodash';
_.contains = _.includes;
_.pluck = (items, iteratee) => _.map(items, iteratee);
import 'expose-loader?Backbone!backbone';

import 'zoomforth_file_uploader/file-uploader-shim.js';

import 'jquery.progresspie-1.3.0/jquery-progresspiesvg.js';
import 'expose-loader?emailAddresses!email-addresses/email-addresses.js';
        
import zfrespond from 'expose-loader?zfrespond!zoomforth_zfrespond/zfrespond_setup.js';


import 'zoomforth_zfrespond/models/exposed_collector.js';
import 'zoomforth_zfrespond/models/exposed_contact_campaign.js';
import 'zoomforth_zfrespond/models/exposed_field.js';
import 'zoomforth_zfrespond/models/response.js';


import 'zoomforth_zfrespond/views/field_selector.js';
import 'zoomforth_zfrespond/views/optout.js';
import 'zoomforth_zfrespond/views/respond.completed_modal.js';
import 'zoomforth_zfrespond/views/respond.edit_media_response.js';
import 'zoomforth_zfrespond/views/respond.edit_text_response.js';
import 'zoomforth_zfrespond/views/respond.js';
import 'zoomforth_zfrespond/views/respond.media_response_thumbnail.js';
import 'zoomforth_zfrespond/views/respond.mobile_video_interstitial.js';
import 'zoomforth_zfrespond/views/respond.questions_header.js';
import 'zoomforth_zfrespond/views/respond.respond_app.js';
import 'zoomforth_zfrespond/views/welcome.js';

import 'webrtc-adapter/adapter_no_edge.js';

export default zfrespond;